import { render, staticRenderFns } from "./WorkspaceItem.vue?vue&type=template&id=296730c6&scoped=true&"
import script from "./WorkspaceItem.vue?vue&type=script&lang=js&"
export * from "./WorkspaceItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceItem.vue?vue&type=style&index=0&id=296730c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296730c6",
  null
  
)

export default component.exports